export default __webpack_public_path__ + "static/media/DoubleDay_1280x500.7731bfab.jpg";